import { memo, useState } from 'react';
import { useIntl } from 'react-intl';
import { clsx } from 'clsx';
import useTabletView from '../../../core/hooks/dom/useTabletView';
import LanguageSelector from '../LanguageSelector';
import styles from './UserMenu.module.scss';
import ContactModalMenuItem from './ContactModalMenuItem';
import MenuItem from './MenuItem';
import UserMenuModals from './UserMenuModals';

const UserMenuLoggedOut = () => {
    const isTabletView = useTabletView();
    const [showModals, setShowModals] = useState(false);
    const intl = useIntl();

    return (
        <div className={styles.userMenu}>
            <div
                className={clsx(
                    styles.headerLayout,
                    styles.headerLayoutResponsive
                )}
            >
                <div className={styles.headerLayout}>
                    {!isTabletView && <ContactModalMenuItem />}
                    <LanguageSelector />
                    <div>
                        <MenuItem
                            onClick={() => setShowModals(true)}
                            text={intl.formatMessage({
                                id: 'sign in',
                            })}
                        />
                        {showModals && (
                            <UserMenuModals
                                onClose={() => {
                                    setShowModals(false);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(UserMenuLoggedOut);
